(() => {
  const RAIL_SELECTOR =
    "product-info[id^='MainProduct-'] [id^='GalleryThumbnails-'] .thumbnail-list";
  const ITEM_SELECTOR = '.thumbnail-list__item';
  const ACTIVE_SELECTOR = '.thumbnail[aria-current="true"]';
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const isVerticalRail = (rail) => {
    if (!desktopQuery.matches || !rail) return false;

    const styles = window.getComputedStyle(rail);
    return styles.flexDirection === 'column' && /auto|scroll/.test(styles.overflowY);
  };

  const keepActiveThumbnailVisible = (button) => {
    if (!button || button.getAttribute('aria-current') !== 'true') return;

    const item = button.closest(ITEM_SELECTOR);
    const rail = item?.closest('.thumbnail-list');
    if (!item || !isVerticalRail(rail)) return;

    const railRect = rail.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const tolerance = 2;
    const isAbove = itemRect.top < railRect.top + tolerance;
    const isBelow = itemRect.bottom > railRect.bottom - tolerance;

    if (!isAbove && !isBelow) return;

    const centeredTop =
      rail.scrollTop +
      (itemRect.top - railRect.top) -
      Math.max(0, (rail.clientHeight - itemRect.height) / 2);

    rail.scrollTo({
      top: Math.max(0, centeredTop),
      behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
    });
  };

  const bindRail = (rail) => {
    if (!rail || rail.dataset.switzerVerticalRailBound === 'true') return;
    rail.dataset.switzerVerticalRailBound = 'true';

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'aria-current') return;
        keepActiveThumbnailVisible(mutation.target);
      });
    });

    observer.observe(rail, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current'],
    });

    rail.addEventListener('focusin', (event) => {
      const button = event.target.closest?.('.thumbnail');
      if (button) keepActiveThumbnailVisible(button);
    });

    const activeButton = rail.querySelector(ACTIVE_SELECTOR);
    if (activeButton) keepActiveThumbnailVisible(activeButton);
  };

  const bindAllRails = (root = document) => {
    root.querySelectorAll(RAIL_SELECTOR).forEach(bindRail);
  };

  const init = () => bindAllRails(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindAllRails(event.target);
  });
})();
